import { Col, Form, Input, message, Modal, Row } from "antd";
import { Rule } from "antd/lib/form";
import { businessTypeApi } from "api/business-type.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { BusinessType } from "types/business-type";
import { InputNumber } from "components/Input/InputNumber";

const rules: Rule[] = [{ required: true }];

export const BusinessTypeModal = ({
  visible,
  status,
  businessType,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  status: ModalStatus;
  businessType: Partial<BusinessType>;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = Form.useForm<BusinessType>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (status == "create" && visible) {
      form.resetFields();
    }
  }, [visible, status]);

  useEffect(() => {
    form.setFieldsValue({ ...businessType });
    return () => {};
  }, [businessType]);

  const createData = async () => {
    const valid = await form.validateFields();
    const data = { businessType: form.getFieldsValue() };

    setLoading(true);
    try {
      const res = await businessTypeApi.create(data);
      message.success("Tạo mới thành công");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const updateData = async () => {
    const valid = await form.validateFields();
    const data = { businessType: form.getFieldsValue() };
    setLoading(true);
    try {
      const res = await businessTypeApi.update(businessType?.id || 0, data);
      message.success("Cập nhật thành công");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={status == "create" ? "Thêm mới" : "Cập nhật"}
      style={{ top: 20 }}
      width={600}
      confirmLoading={loading}
      okText="Lưu"
      cancelText="Đóng"
      onOk={() => {
        status == "create" ? createData() : updateData();
      }}
    >
      <Form layout="vertical" form={form}>
        <Form.Item label="Tên" name="name" rules={rules}>
          <Input placeholder="" />
        </Form.Item>

        <Form.Item
          label="Vị trí (Thấp nhất là trên cùng)"
          name="position"
          rules={rules}
        >
          <InputNumber />
        </Form.Item>

        <Form.Item shouldUpdate={true}>
          {() => {
            return (
              <Form.Item label="Icon" name="image">
                <SingleImageUpload
                  onUploadOk={(path: string) => {
                    console.log("onUploadOk:", path);
                    form.setFieldsValue({
                      image: path,
                    });
                  }}
                  imageUrl={form.getFieldValue("image")}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      </Form>
    </Modal>)
  );
};
